import React, { useContext } from "react";
import OficinaVirtualControllerContextProvider, {
  OficinaVirtualControllerContext,
} from "../../context/OficinaVirtualControllerContextProvider";
import GenericReportTable from "../../../GenericReportTable";
import Loading from "../../../../../common/components/Loading";
import Pagination from "../../../../../common/components/Pagination";
import { splitArray } from "../../../../../common/utils/utilsFunc";
import { CGE } from "../../../../../common/components/CGE";
import arTitles from "../../../../../common/services/mock/title.json";

function OficinaVirtualController({ props }) {
  const [state] = useContext(OficinaVirtualControllerContext);
  const [loading, setLoading] = React.useState(false);

  const [activePage, setActivePage] = React.useState(1);
  const [activePage1, setActivePage1] = React.useState(1);
  const [activePage2, setActivePage2] = React.useState(1);

  const [rowPage, setRowPageList] = React.useState(10);
  const [rowPage1, setRowPageList1] = React.useState(10);
  const [rowPage2, setRowPageList2] = React.useState(10);

  const [auxArray, setAuxArray] = React.useState([]);
  const [auxArray1, setAuxArray1] = React.useState([]);
  const [auxArray2, setAuxArray2] = React.useState([]);

  const [currentArray, setCurrentArray] = React.useState([]);
  const [currentArray1, setCurrentArray1] = React.useState([]);
  const [currentArray2, setCurrentArray2] = React.useState([]);

  const [newArrTitle, setNewArrTitle] = React.useState(null);
  const [newArrTitle1, setNewArrTitle1] = React.useState(null);
  const [newArrTitle2, setNewArrTitle2] = React.useState(null);

  var currentTime = new Date()
  var currentYear = currentTime.getFullYear();
  React.useEffect(() => {
    setNewArrTitle(arTitles["oficina-virtual"]?.map((item) => item.label));
    setNewArrTitle1(arTitles["oficina-virtual"]?.map((item) => item.label));
    setNewArrTitle2(
      arTitles["oficina-virtual-total"]?.map((item) => item.label)
    );
  }, []);

  function setRowPage1(nPage) {
    setActivePage1(1);
    setRowPageList1(Number(nPage));
  }

  var panelFooter1 = (
    <>
      {auxArray1?.length > 0 && (
        <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
          <Pagination
            items={auxArray1}
            onChangePage={setActivePage1}
            qtdRowPage={props.qtdRowPage}
            setRowPage={setRowPage1}
            pageSize={rowPage1}
            currentPg={activePage1}
          />
        </div>
      )}
    </>
  );

  React.useEffect(() => {
    let arrayOfarrays = [];
    let arrayOfarrays1 = [];
    let arrayOfarrays2 = [];
    arrayOfarrays = splitArray(auxArray, rowPage);
    arrayOfarrays1 = splitArray(auxArray1, rowPage1);
    arrayOfarrays2 = splitArray(auxArray2, rowPage2);
    setCurrentArray(arrayOfarrays[activePage - 1]);
    setCurrentArray1(arrayOfarrays1[activePage1 - 1]);
    setCurrentArray2(arrayOfarrays2[activePage2 - 1]);
  }, [
    activePage,
    activePage1,
    activePage2,
    auxArray,
    auxArray1,
    auxArray2,
    rowPage,
    rowPage1,
    rowPage2,
  ]);

  React.useEffect(() => {
    if (!state.dataTable) {
      setLoading(true);
    } else {
      const objResponse = state.dataTable;
      setLoading(false);

      if (objResponse?.empresas?.length > 0) {
        let auxAr1 = [];
        let auxAr2 = [];
        objResponse?.empresas[0]?.months.forEach(obj => auxAr1.push({
          mes:obj.month,
          sesion:obj.sesion,
          pago:obj.pago,
          consultarContingencia:obj.consultarContingencia,
          reliquicadion:obj.reliquicadion,
          total:obj.total,
        }));
        objResponse?.empresas[1]?.months.forEach(obj => auxAr2.push({
          mes:obj.month,
          sesion:obj.sesion,
          pago:obj.pago,
          consultarContingencia:obj.consultarContingencia,
          reliquicadion:obj.reliquicadion,
          total:obj.total,
        }));
        setAuxArray(auxAr1);
        setAuxArray1(auxAr2);
        setAuxArray2([
          {
            sesionTotal: objResponse?.sesionTotal,
            pagoTotal: objResponse?.pagoTotal,
            consultarContingenciaTotal: objResponse?.consultarContingenciaTotal,
            reliquicadionTotal: objResponse?.reliquicadionTotal,
            total: objResponse?.total,
          },
        ]);
      } else if (objResponse?.empresas?.length === 0) {
        props.setGlobalAlert(
          "No se encontraron registros",
          "warning",
          true,
          "Advertencia"
        );
        setAuxArray([]);
        setAuxArray1([]);
        setAuxArray2([]);
      } else {
        props.setGlobalAlert(
          "El servicio no está disponible actualmente, intente más tarde.",
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.dataTable]);

  let propsTable = {
    nameTabs: ["CGE - "+currentYear,"EDELMAG - "+currentYear,"TOTAL"],
    fileName: props.title_page_oficina_virtual,
    auxArray: [auxArray,auxArray1,auxArray2],
    arTitles: [newArrTitle, newArrTitle1, newArrTitle2],
    disabled: currentArray?.length > 0 ? false : true,
  };

  let panelActions = (
    <>
      <CGE.InlineRow>
        <CGE.InlineCol>
          <CGE.ButtonExcelMultipleTable props={propsTable} />
        </CGE.InlineCol>
      </CGE.InlineRow>
    </>
  );

  return (
    <div>
      <CGE.Panel
        title={props.title_page_oficina_virtual}
        topContent={panelActions}
        description={`Fecha (Inicio): ${state.dataTable?.startDate} - Fecha (Fin): ${state.dataTable?.endDate}`}
      >
        {currentArray?.length > 0 && (
          <GenericReportTable
            props={{
              ...props,
              currentArray,
              newArrTitle,
              customTitle:
                "CGE" +
                " - " +
                currentYear,
              topContent: <></>,
            }}
          />
        )}
      </CGE.Panel>
      <CGE.Panel footerContent={panelFooter1}>
        {currentArray1?.length > 0 && (
          <GenericReportTable
            props={{
              ...props,
              currentArray: currentArray1,
              newArrTitle: newArrTitle1,
              customTitle:
                "EDELMAG" +
                " - " +
                currentYear,
              topContent: <></>,
            }}
          />
        )}
      </CGE.Panel>
      <CGE.Panel>
        {currentArray2?.length > 0 && (
          <GenericReportTable
            props={{
              ...props,
              currentArray: currentArray2,
              newArrTitle: newArrTitle2,
              customTitle: "TOTAL",
            }}
          />
        )}
      </CGE.Panel>
      {loading && <Loading />}
    </div>
  );
}

const OficinaVirtualControllerWithProvider = ({ props }) => (
  <OficinaVirtualControllerContextProvider>
    <OficinaVirtualController props={props} />
  </OficinaVirtualControllerContextProvider>
);
export default OficinaVirtualControllerWithProvider;